// test1125
(1125 && 0);
